import React from "react";
import { CVDocuments } from "../CVs/CVDocuments";
import { DocOnlineDocuments } from "../DocOnline/DocOnlineDocuments";
import { OtherDocuments } from "../Others/OtherDocuments";
import { SimulationDocuments } from "../Simulations/SimulationDocuments";
import { ProposalsDocuments } from "../Proposals/ProposalsDocuments";
import { useGeneralContext } from "../../../General/Context";

export default function DocumentsDetailSection({
  interview,
  interviewId,
  updateDocumentsGrid,
  disabled,
  fromUrl,
  permissions,
  refreshDocuments
}) {

  return (
    <div class="accordion accordion-flush" id="accordionFlushDocuments">
      <CVDocuments
        interviewId={interviewId}
        updateDocumentsGrid={updateDocumentsGrid}
        disabled={disabled}
        refreshDocuments={refreshDocuments}
      />
      <DocOnlineDocuments
        interviewId={interviewId}
        updateDocumentsGrid={updateDocumentsGrid}
        disabled={disabled}
        interview={interview}
      />
      <OtherDocuments
        interviewId={interviewId}
        updateDocumentsGrid={updateDocumentsGrid}
        disabled={disabled}
      />

      {permissions?.Use_Project_Simulation && (
        <SimulationDocuments
          candidateEmail={interview?.personalInformation.emailAddress}
          interviewId={interviewId}
          fromUrl={fromUrl}
          fullName={interview?.personalInformation.fullName}
        />
      )}
      {permissions?.List_View_PreProposal && (
        <ProposalsDocuments
          interviewId={interviewId}
          updateDocumentsGrid={updateDocumentsGrid}
          candidateEmail={interview?.personalInformation.emailAddress}
          disabled={disabled}
        />
      )}
    </div>
  );
}
